import CodeLeaveTypeList from "./pages/ListPage.vue";
import CodeLeaveTypeDetail from "./pages/FormPage.vue";
import CodeLeaveTypeIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/code_leave_type",
    component: CodeLeaveTypeIndex,
    redirect: "/code_leave_type/list",
    name: "code_leave_type",
    children: [
      {
        path: "list",
        component: CodeLeaveTypeList,
        name: "code_leave_type.list",
      },
      {
        path: "create",
        component: CodeLeaveTypeDetail,
        name: "code_leave_type.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: CodeLeaveTypeDetail,
        name: "code_leave_type.edit",
        props: { create: false },
      },
    ],
  },
];
